import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
//import { LocalstorageService } from 'src/app/global/localstorage.service';
import { MatDialog } from '@angular/material';
import { LocalstorageService } from '../../../app/global/localstorage.service';
import { BusService } from 'src/app/main/busservices/busservice.service';
import { first, groupBy, mergeMap, toArray } from 'rxjs/operators';
import * as data from '../../../assets/projectconfig.json';
import { ViewRoutesService } from '../viewroutes/viewroutes.service';
import { from, interval, Subscription } from 'rxjs';
import { PlanjourneyService } from '../planjourney/planjourney.service';
import { StringFilterCellComponent } from '@progress/kendo-angular-grid';
import { UpdatefontsizeService } from '../../services/updatefontsize.service';
import { LoginDialog } from '../../shared/layout/header/header.component'
'../header/header.component';
import { NotificationService } from '../shared/notification.service';
import { GetPassHistory,InsertPassRenew,PasssListByMobile,PassDetailsByPassNo,GetFrequencyByType,GetRouteByStation,PassDetailsPayment,ModelPayment,GetFare,UnltdPassResponse} from '../onlineservices/onlineservices';
import { OnlineserviceService } from '../onlineservices/onlineservice.service';
import {FormControl,FormGroup,Validators} from '@angular/forms';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
//import {MomentDateAdapter} from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { formatDate } from '@progress/kendo-angular-intl';
import {Common} from 'src/utility/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-busservices',
  templateUrl: './busservices.component.html',
  styleUrls: ['./busservices.component.scss']
})
export class BusservicesComponent implements OnInit {

  public RouteNoForMap: any;
  public NameOfRoutes: any;
  num: any;
  public isLogin: any;
  isShow: any;
  NavName: string;
  getlen: string;
  BusServicesLan: string;
  HomeLan: string;
  FareConcessionsLan: string;
  FareConcessionsLan2: string;
  RegularBusesLan: string;
  RailwayStationServicesLan: string;
  RouteMap: string;
  BusNetworkLan: string;
  routenolan: string;
  routenamelan: string;
  routemaplan: string;
  timetablelan: string;
  stopslan: string;
  categorylan: string;
  concessionlan: string;
  kidslan: string;
  blinddiffrentlan: string;
  helperscompanionslan: string;
  number1: string;
  number2: string;
  number3: string;
  searchlan: string;
  PassesLan: string;
  HistoryLan:string;
  RenewalLan:string;
  ApplyRenewalLan:string;
  RailwayStationServicesLan2: string;
  RegularBusespara1: string;
  RegularBusespara2: string;
  para2: string;
  para3: string;
  para4: string;
  ComingsoonLan: string;
  SelectedNavBar: number;
  Name: string;
  HonName: string;
  urlName: string;
    Railwaystationservicespara1: string;
  passesimageLan: string;
  Fareconessionimage: string;
  parsedData: any[];
  price1: string;
  price2: string;
  price3: string;
  price4: string;
  price5: string;
  price6: string;
  passdura: string;
  Day1: string;
  Day2: string;
  Day3: string;
  Day4: string;
  Day5: string;
  Day6: string;
  amount: string;
  passengertype: string;
  passtype: string;
  general: string;
  openend: string;
  consession: string;
  con1: string;
  con2: string;
  con3: string;
  con4: string;
  con5: string;
  con6: string;
  con7: string;
  gene1: string;
  student: string;
  consess: string;
  pay1: string;
  pay2: string;
  public TypeofRoute: any;
  public showPass=0;

  //Pass history
  lstHistory:any=[];
  lan:string;
  arr:any=[];
  lblPasstype:string;
  lblFrom:string;
  lblTo:string;
  lblRunning:string;
  lblExpired:string;
  lblRefno:string;
  lblRoutes:string;
  lblIssueDate:string;
  lblValidDate:string;
  lblExpiredDate:string;
  lblRouteSpecific:string;
  lblOpenended:string;
  lblStu:string;
  lblOrd:string;
  lblStudent:string;
  lblNoData:string;
  isDataFound:boolean=false;
  token:string ="";
  userid:string ="";
  MobileNo:string="";

    public lim: any = [];
    fontSize = 14;
    NASize = this.fontSize;

    constructor(public router: Router, private route: ActivatedRoute, public dialog: MatDialog, public BusService: BusService,
      private onlineservices: OnlineserviceService, private updateFont: UpdatefontsizeService) {
    this.getlen = LocalstorageService.getLanguage("language");
  }

  slider_images = [
    'assets/images/webenglish.png',
    // 'assets/images/WebPortalBanners/update/1.jpg',
    // 'assets/images/WebPortalBanners/update/2.jpg',
    // 'assets/images/WebPortalBanners/update/3.jpg',
    // 'assets/images/WebPortalBanners/update/4.jpg',
    // 'assets/images/WebPortalBanners/update/5.jpg',
    // 'assets/images/WebPortalBanners/update/6.jpg',
    /*'assets/images/WebPortalBanners/update/3.jpeg',
    'assets/images/WebPortalBanners/update/4.jpeg',*/
    /*'assets/images/WebPortalBanners/updated/Bus_banner_3.jpg',
    'assets/images/WebPortalBanners/updated/1.jpg',
    'assets/images/WebPortalBanners/updated/2.jpg',
    'assets/images/WebPortalBanners/updated/3.jpg',
    'assets/images/WebPortalBanners/updated/4.jpg',
    'assets/images/WebPortalBanners/updated/5.jpg',
    'assets/images/WebPortalBanners/updated/6.jpg',
    'assets/images/WebPortalBanners/updated/7.jpg',*/
  ]

  event_list = [
    {
      event:' Event 1',
      eventLocation:'Bangalore',
      eventDescription:'In bangalore, first event is going to happen. Please be careful about it',
      img: 'assets/images/WebPortalBanners/updated/Bus_banner_3.jpg',
      eventStartDate: new Date('2019/05/20'),
      eventEndingDate: new Date('2019/05/24')
    },
    {
      event:' Event 2',
      eventLocation:'Bangalore',
      eventDescription:'In bangalore, first event is going to happen. Please be careful about it',
      img: 'assets/images/WebPortalBanners/1.jpg',
      eventStartDate: new Date('2019/05/20'),
      eventEndingDate: new Date('2019/05/24')
    },
     {
      event:' Event 3',
      eventLocation:'Dubai',
      eventDescription:'Dubai is another place to host so,e, first event is going to happen. Please be careful about it',
      img: 'assets/images/WebPortalBanners/2.jpg',
      eventStartDate: new Date('2019/07/28'),
      eventEndingDate: new Date('2019/07/30')
    },
     {
      event:' Event 4',
      eventLocation:'New York',
      eventDescription:'NewYork sits on top of event hosting',
      img: 'assets/images/WebPortalBanners/3.jpg',
      eventStartDate: new Date('2020/05/20'),
      eventEndingDate: new Date('2020/05/24')
    },
     {
      event:' Event 5',
      eventLocation:'Singapore',
      eventDescription:'Singapore is another great hosting city',
      img: 'assets/images/WebPortalBanners/4.jpg',
      eventStartDate: new Date('2018/05/20'),
      eventEndingDate: new Date('2018/05/24')
    },
    {
      event:' Event 6',
      eventLocation:'Berlin',
      eventDescription: 'Berlin is best place to hang on',
      img: 'assets/images/WebPortalBanners/5.jpg',
      eventStartDate: new Date('2017/07/10'),
      eventEndingDate: new Date('2017/08/14')
    },
    {
      event:' Event 7',
      eventLocation:'Mumbai',
      eventDescription:'Mumbai is hub of startups',
      img: 'assets/images/WebPortalBanners/6.jpg',
      eventStartDate: new Date(),
      eventEndingDate: new Date()
    },
    {
      event:' Event 8',
      eventLocation:'Barcelona',
      eventDescription:'Barcelona is another good city',
      img: 'assets/images/WebPortalBanners/7.jpg',
      eventStartDate: new Date(),
      eventEndingDate: new Date()
    },
  ]

  ngOnInit() {
    //Ghanshyam 22july2022
    /*this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.userid = params['userid'];
      this.MobileNo = params['MobileNo'];
    });

    if((this.token !='' && this.token != undefined && this.token != null))
    {
      if(this.token.length>0 )
      {
        LocalstorageService.setLocal('user', this.userid);   //Set the Userid In LocalStorage
        LocalstorageService.setLocal('mobileno', this.MobileNo);   // Set MobileNo In LocalStorage For SmartCard
        LocalstorageService.setLocal('user_NMC', this.userid);   //Set the Userid In LocalStorage
        LocalstorageService.setLocal('mobileno_NMC', this.MobileNo);
        LocalstorageService.setLocal('Token', this.token);
        localStorage.setItem('currentUser', JSON.stringify("{'token':"+this.token+",'UserName':'','Userid':"+this.userid +" }"));

      }

    }
    */

    this.lim.push(1);
    this.lim.push(2);
    this.GetRoutesList();
    this.num = this.route.snapshot.queryParamMap.get('page');
    this.Getdata(this.num);
    this.isLogin = LocalstorageService.getLanguage('user_NMC');
    var user=localStorage.getItem('user_NMC');
    this.GetPassHistory(Number(user));
    if (this.getlen == 'en') {
      this.BusServicesLan = "BUS SERVICES";
      this.HomeLan = "HOME";
      this.FareConcessionsLan = "FARE CONCESSIONS";
      this.FareConcessionsLan2 = "FARE CONCESSIONS"
      this.RegularBusesLan = "REGULAR BUSES";
      this.RailwayStationServicesLan = "RAILWAY STATION AND AIRPORT SERVICES";
      this.RouteMap = "ROUTE";
      this.RailwayStationServicesLan2 = "Frequently Asked Questions (FAQs)";
      this.BusNetworkLan = "BUS NETWORK";
      this.routenolan = "Route No";
      this.routenamelan = "Route Name";
      this.routemaplan = "Route Map";
      this.timetablelan = "Timetable";
      this.stopslan = "Stops";
      this.categorylan = "Category";
      this.concessionlan = "Concessions(50%)";
      this.kidslan = "Kids 5-10 years";
      this.blinddiffrentlan = "Blind and Differently-abled";
      this.helperscompanionslan = "Helpers/Companions to Differently-abled";
      this.number1 = "50%";
      this.number2 = "75%";
      this.number3 = "50%";
      this.passengertype = "Passenger Type";
      this.passtype = "Pass Type";
      this.general = "General";
      this.openend = "Open Ended (Anywhere, Any Route)";
      this.passdura = "Pass Duration";
      this.Day1 = "1 Day";
      this.Day2 = "3 Days";
      this.Day3 = "7 Days";
      this.Day4 = "30 Days";
      this.Day5 = "90 Days";
      this.Day6 = "180 Days";
      this.amount = "Amount (Rs.)";
      this.price1 = "Rs.75/-";
      this.price2 = "Rs.200/-";
      this.price3 = "Rs.400/-";
      this.price4 = "Rs.1500/-";
      this.price5 = "Rs.3750/-";
      this.price6 = "Rs.6750/-";
      this.consession = "Concession (%)";
      this.con1 = "Nil";
      this.con2 = "12.50%";
      this.con3 = "26.80%";
      this.con4 = "33.33%";
      this.con5 = "44.44%";
      this.con6 = "50%";
      this.con7 = "66.60%";
      this.gene1 = "General (Fixed Route)";
      this.student = "Student (Fixed Route)";
      this.consess = "Concession";

      this.pay1 = "33.33%";
      this.pay2 = "44.44%";

      this.searchlan = "Search With Route No Or Route Name";
      this.PassesLan = "PASSES";
      this.HistoryLan = "PASS HISTORY";
      this.RenewalLan="PASS RENEW";
      this.ApplyRenewalLan="Apply For Pass Renew";

      this.RegularBusespara1 = "Presently the routes cover a radius of 20 kms in and around Nashik area. Nearly 250 buses providing services to the passengers every day.";
      this.RegularBusespara2 = "See bus route schedule for more information.";

      this.Railwaystationservicespara1 = "Nashik city will be connected to Nashik Road Railway Station by city bus with 5 minutes frequency. Also, it will be connected to Nashik Airport with frequent service.";

      this.para3 = "When customers do have questions that extend beyond the range of your FAQ page, you should have options available that directly connect them with your support team. You could add a link that opens a new support ticket or even just list your call center's phone number at the bottom of the page.The idea is that customers shouldn't have to navigate back to your home page just to locate your company's email or phone number.";
      this.para4 = "This committee, specified under The MMC Act is the most important committee of the corporation. The councilors at their first meeting elect the Standing Committee, consisting of 16 councillors, after the general election. The Standing Committee/General Board essentially governs the functioning of the Corporation on behalf of the 122 councillors. It is the policy making body of the Corporation and makes all decisions with respect to the establishment and finances of the Corporation as per the various provisions of the MMC Act 1949.";
      this.passesimageLan="../../../../assets/images/Passes-en.jpg";
      this.Fareconessionimage="../../../../assets/images/Fareconsession-en.jpg";
      this.ComingsoonLan = "Coming Soon..."
      this.Name = "Smt. Manisha Khatri (I.A.S.)";
      this.HonName = "Chairman and Managing Director,Nashik Mahanagar Parivahan Mahamandal Limited. Administrator Nashik Municipal Corporation Nashik."
      this.lblPasstype="Pass Type";
      this.lblFrom="From";
      this.lblTo="To";
      this.lblRunning="Running";
      this.lblExpired="Expired";
      this.lblRefno="Reference No.";
      this.lblRoutes="Routes";
      this.lblIssueDate="Issue Date";
      this.lblValidDate="Valid From";
      this.lblExpiredDate="Expired On";
      this.lblRouteSpecific="Route Specific Pass";
      this.lblOpenended="Open Ended Pass";
      this.lblStu="Student Pass";
      this.lblOrd="Ordinary";
      this.lblStudent="Student";
      this.lblNoData="No Pass History Available!....";

    }
    else if (this.getlen == 'mr') {
      this.BusServicesLan = "बस सेवा";
      this.HomeLan = "मुख्यपृष्ठ";
      this.RegularBusesLan = "नियमित बसेस";
      this.RegularBusespara1 = "सध्याच्या वाहतुक नियोजनानुसार नाशिक शहर व त्याच्या २० कि.मी. पर्यंतच्या भागांमध्ये दररोज सुमारे 250 बसेस सुरु करुन नागरिकांना सेवा पुरविण्यात येणार आहे.";
      this.RegularBusespara2 = "अधिक माहितीसाठी बस मार्गाचे वेळापत्रक पाहावे. "
      this.RailwayStationServicesLan = "रेल्वे स्टेशन व विमानतळ सेवा";
      this.RailwayStationServicesLan2 = "नेहमी विचारले जाणारे प्रश्न (वारंवार विचारले जाणारे प्रश्न)";
      this.BusNetworkLan = "बस नेटवर्क";
      this.routenolan = "मार्ग क्र.";
      this.routenamelan = "मार्गाचे नाव";
      this.routemaplan = "मार्ग नकाशा";
      this.timetablelan = "वेळापत्रक";
      this.stopslan = "बस थांब्यांची यादी";
      this.categorylan = "वर्गवारी";
      this.concessionlan = "सवलत";
      this.kidslan = "लहान मुले ०५ ते १० वर्षा आतील";
      this.blinddiffrentlan = "अंध व अपंग";
      this.helperscompanionslan = "मदतनीस (अंध व अपंग यासाठी)";
      this.number1 = "५०%";
      this.number2 = "७५%";
      this.number3 = "५०%";
      this.passengertype = "प्रवाशांचे प्रकार";
      this.passtype = "पास प्रकार";
      this.general = "पासवर दिल्या जाणा-या सवलती";
      this.openend = "अमयागद पास";
      this.passdura = "पासकालावधी";
      this.Day1 = "१ दिवस";
      this.Day2 = "३ दिवस";
      this.Day3 = "७ दिवस";
      this.Day4 = "३० दिवस";
      this.Day5 = "९० दिवस";
      this.Day6 = "१८० दिवस";
      this.amount = "किंमत (रु)";
      this.price1 = "रु.७५/-";
      this.price2 = "रु.२००/-";
      this.price3 = "रु.४००/-";
      this.price4 = "रु.१५००/-";
      this.price5 = "रु.३७५०/-";
      this.price6 = "रु.६७५०/-";
      this.consession = "सवलत (%)";
      this.con1 = "-";
      this.con2 = "१२ .५०%";
      this.con3 = "२६.८०%";
      this.con4 = "३३.३३%";
      this.con5 = "४४ .४४%";
      this.con6 = "५०%";
      this.con7 = "६६.६०%";
      this.gene1 = "सवगसाधारण (निश्चित मार्ग )";
      this.student = "विद्यार्थी (निश्चित मार्ग )";
      this.consess = "सवलत";
      this.pay1 = "२० दिवसाच्या भाडयावर ३० दिवस प्रवास";
      this.pay2 = "५० दिवसाच्या भाडयावर ९० दिवस प्रवास";
      this.searchlan = "मार्गाचे नाव किंवा मार्ग क्र. द्वारे शोधा";
      this.FareConcessionsLan = "तिकिटांवर सवलती";
      this.FareConcessionsLan2 = "तिकीटदरावर दिल्या जाणा-या सवलती";
      this.PassesLan = "पास माहिती";
      this.HistoryLan = "पास इतिहास";
      this.RenewalLan="पास नूतनीकरण";
      this.ApplyRenewalLan="पास नूतनीकरण करण्यासाठी अर्ज करा";

      this.ComingsoonLan = "लवकरच येत आहे…";
      this.Railwaystationservicespara1 = "'CITILINC' शहर बससेवेचे नियोजन ओझर विमानतळ आणि नाशिक रोड रेल्वे स्थानकाचे वेळापत्रक लक्षात घेऊन करण्यात आले आहे. नाशिक रोड येथून नाशिक शहरातील सर्व महत्वाच्या ठिकाणी आणि तपोवन डेपोतून ओझर विमानतळ मार्गे मोहाडी पर्यंत बसेस उपलब्ध असणार आहेत. ";
      this.para2 = "FAQ pages are intended as an initial support option for customers looking for an immediate answer to a quick question or problem. It shouldn't replace your knowledge base or your entire support team, but rather supplement your support channels as an additional, lightweight resource.";
      this.para3 = "When customers do have questions that extend beyond the range of your FAQ page, you should have options available that directly connect them with your support team. You could add a link that opens a new support ticket or even just list your call center's phone number at the bottom of the page.The idea is that customers shouldn't have to navigate back to your home page just to locate your company's email or phone number.";
      this.para4 = "This committee, specified under The MMC Act is the most important committee of the corporation. The councilors at their first meeting elect the Standing Committee, consisting of 16 councillors, after the general election. The Standing Committee/General Board essentially governs the functioning of the Corporation on behalf of the 122 councillors. It is the policy making body of the Corporation and makes all decisions with respect to the establishment and finances of the Corporation as per the various provisions of the MMC Act 1949.";
      this.passesimageLan="../../../../assets/images/Passes-mr.jpg";
      this.Fareconessionimage="../../../../assets/images/Fareconsession-mr.jpg";
      this.Name = "श्रीमती. मनीषा खत्री";
      this.HonName = "अध्यक्ष व व्यवस्थापकीय संचालक,नाशिक महानगर परीवहन महामंडळ लि.तथा प्रशासक नाशिक महानगरपालिका नाशिक.";

      this.lblPasstype="पास प्रकार";
        this.lblFrom="पासून";
        this.lblTo="ला";
        this.lblRunning="धावणे";
        this.lblExpired="कालबाह्य";
        this.lblRefno="संदर्भ क्रमांक.";
        this.lblRoutes="मार्ग";
        this.lblIssueDate="जारी करण्याची तारीख";
        this.lblValidDate="पासून वैध";
        this.lblExpiredDate="रोजी कालबाह्य झाले";
        this.lblRouteSpecific="मार्ग विशिष्ट पास";
        this.lblOpenended="ओपन एन्ड पास";
        this.lblStu="विद्यार्थी पास";
        this.lblOrd="सामान्य";
        this.lblStudent="विद्यार्थी";
        this.lblNoData="कोणताही पास इतिहास उपलब्ध नाही!....";

    } else {
      this.BusServicesLan = "BUS SERVICES";
      this.HomeLan = "HOME";
      this.FareConcessionsLan = "FARE CONCESSIONS";
      this.RegularBusesLan = "REGULAR BUSES";
      this.RailwayStationServicesLan = "RAILWAY STATION SERVICES";
      this.RailwayStationServicesLan2 = "Frequently Asked Questions (FAQs)";
      this.BusNetworkLan = "BUS NETWORK";
      this.PassesLan = "PASSES";
      this.HistoryLan = "PASS HISTORY";
      this.RenewalLan="PASS RENEW";
      this.Railwaystationservicespara1 = "Nashik city will be connected to Nashik Road Railway Station by city bus with 5 minutes frequency.";      this.para3 = "When customers do have questions that extend beyond the range of your FAQ page, you should have options available that directly connect them with your support team. You could add a link that opens a new support ticket or even just list your call center's phone number at the bottom of the page.The idea is that customers shouldn't have to navigate back to your home page just to locate your company's email or phone number.";
      this.para4 = "This committee, specified under The MMC Act is the most important committee of the corporation. The councilors at their first meeting elect the Standing Committee, consisting of 16 councillors, after the general election. The Standing Committee/General Board essentially governs the functioning of the Corporation on behalf of the 122 councillors. It is the policy making body of the Corporation and makes all decisions with respect to the establishment and finances of the Corporation as per the various provisions of the MMC Act 1949.";
      this.passesimageLan="../../../../assets/images/Passes-en.jpg";
      this.Fareconessionimage="../../../../assets/images/Fareconsession-en.jpg";

      this.lblPasstype="Pass Type";
        this.lblFrom="From";
        this.lblTo="To";
        this.lblRunning="Running";
        this.lblExpired="Expired";
        this.lblRefno="Reference No.";
        this.lblRoutes="Routes";
        this.lblIssueDate="Issue Date";
        this.lblValidDate="Valid From";
        this.lblExpiredDate="Expired On";
        this.lblRouteSpecific="Route Specific Pass";
        this.lblOpenended="Open Ended Pass";
        this.lblStu="Student Pass";
        this.lblOrd="Ordinary";
        this.lblStudent="Student";
        this.lblNoData="No Pass History Available!....";

    }

    this.SelectedNavBar = this.num;

     //update font size daynamic
     this.updateFont.currentFontSource$.subscribe((type) => {
      if(type == '+'){
        if (this.fontSize < (this.NASize + 3)) {
          this.fontSize++;
        }
      } else if(type == '-'){
        if (this.fontSize > (this.NASize - 3)) {
          this.fontSize--;
        }
      } else{
          this.fontSize = this.NASize;
      }
    });
  }

  public RouteStartpointItems: Array<{ routeid: string, routename: string, routeno: any, routenametype: any }>;



  GetRoutesList() {
    this.BusService.GetAllRoutes().pipe(first()).subscribe(result => {
      this.RouteStartpointItems = JSON.parse(result.data);
      // console.log(this.RouteStartpointItems);
    });
  }

  filterMetadata = { count: 0 };
  filtre: any;



  Getdata(b) {
    var URLName='Busservices';
    this.SelectedNavBar=b;
    this.isShow = b;
    this.isLogin = LocalstorageService.getLanguage('user_NMC');
    if(b==5 || b==6 || b==7)
    {
      LocalstorageService.setLocal('geturl',URLName);   // Set Clicked URL into LocalStorageService
      if(this.isLogin == null){
        this.showPass=0;
        //this.router.navigate(['/Login']);
        const dialogRef = this.dialog.open(LoginDialog);

        dialogRef.afterClosed().subscribe(result => {
          console.log(`Dialog result: ${result}`);
        });
      }
      else{

        if(b==6)
        {
          debugger;
          this.showPass=6;
          this.router.navigate(['/' + URLName.split('?')[0]], { queryParams: { page: 6 }});
        }
        if(b==7)
        {
          debugger;
          this.showPass=7;
          this.router.navigate(['/' + URLName.split('?')[0]], { queryParams: { page: 7 }});
        }
        else
        {
          this.showPass=1;
          this.router.navigate(['/' + URLName.split('?')[0]], { queryParams: { page: 5 }});
        }
      }
    }

  }

  goOnTo(id) {
    this.urlName = "Onlineservices";
    this.router.navigate(['/' + this.urlName.split('?')[0]], { queryParams: { page: id } });
  }

  GetPassHistory(id:number)
  {
    var objModel=new GetPassHistory();
    // objModel.intPassUserID=179;
    objModel.intPassUserID=Number(LocalstorageService.getLocal('user_NMC'));
    this.onlineservices.GetPassHistory(objModel).pipe(first()).subscribe(result=>
      {
        console.log(result.data);
        if(result.data!=null)
        {
          if(result.data.length>0)
          {
            this.lstHistory=result.data;
            console.log(this.lstHistory);
              this.arr=[];
            if(this.lstHistory!=null && this.lstHistory.length>0)
            for(let el in this.lstHistory)
            {
              this.arr[el]=this.lstHistory[el].strPassValidRoutes.split("|#|");
            }
            this.isDataFound=true;
          }

        }
        else
        this.isDataFound=false;
      });
  }


  openBusDialog(RouteNo) {
    this.RouteNoForMap = RouteNo;
    LocalstorageService.setLocal("RouteNoForMap",RouteNo);
    const dialogRef = this.dialog.open(RouteMapDialog);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  openTimeTableDialog(RouteNo,displayfullroutename) {
    LocalstorageService.setLocal("RouteNoForMap", RouteNo);
    LocalstorageService.setLocal("NameOfRoutes", displayfullroutename);
    const dialogRef = this.dialog.open(TimeTableDialog);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  openStopsDialog(RouteNo) {
    LocalstorageService.setLocal("RouteNoForMap",RouteNo);
    const dialogRef = this.dialog.open(StopsDialog);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  OpenRenewPassDialog() {
    const dialogRef = this.dialog.open(RenewPassDialog);

    dialogRef.afterClosed().subscribe(result => {
      // console.log(`Dialog result: ${result}`);
    });
  }
}

@Component({
  selector: 'renewPass.design.popup',
  templateUrl: 'renewPass.popup.html',
})
export class RenewPassDialog{
  lblPassType: string;
  lblFreqType: string;
  lblPassAmt: string;
  lblMob: string;
  lblName: string;
  lblPassNo: string;
  lblExpiry: string;
  lblRenewFreq: string;
  getlen: string;

  strMobileNo:string;
  strFullName:string;
  strFrequencyName:string;
  strPassType:string;

  showData:string="false";

  public newForm = new FormGroup({
    drpPassNo:new FormControl("",Validators.required),
    txtFullname: new FormControl("",Validators.required),
    txtMobileNo: new FormControl("",Validators.required),
    txtRenewDate: new FormControl(),
    drpPassFreq: new FormControl("",Validators.required),
    drpPassType: new FormControl("",Validators.required),
    drpPassRenewFreq: new FormControl("",Validators.required),
    txtAmount: new FormControl("",Validators.required),
  });
 public RenewalLan:string;

 public lstPass:any=[];
 public lstPassDetails:any=[];
 lstPassPG:any=[];
 public lstFreqBytype:any=[];
 lstRoute:any=[];
 lstSelectedRouteFare:any=[];
 lstSelectedRoutesWithFare:any=[];
 lstSelRouteMax:any=[];
 lstMax:any=[];
 strSelRoute:string="";
 intFareAmount:any=0;
 intFareAmountEN:any=0;
 public objDetails:PassDetailsByPassNo;
 public dteReneew:Date;
 public dteActivate:Date;
 public objPayment = new ModelPayment();
 public ObjPassDeailsPG=new PassDetailsPayment();
 public objCommonclass = new Common();

 marathiArray:any[]=[{'id':'०'},
 {'id':'१'},
{'id':'२'},
{'id':'३'},
{'id':'४'},
{'id':'५'},
{'id':'६'},
{'id':'७'},
{'id':'८'},
{'id':'९'},
];

public filterSettings: DropDownFilterSettings = {
  caseSensitive: false,
  operator: 'contains'
};

  constructor(private viewRoutesService: ViewRoutesService,private notifyService: NotificationService, private onlineservices: OnlineserviceService,  private journeyService: PlanjourneyService,
    private BusService: BusService,public spinnerService: Ng4LoadingSpinnerService) {
    this.getlen = LocalstorageService.getLanguage("language");
    }

  ngOnInit(): void{
    this.changeLanguage();
  this.createForm();
  this.RenewalLan="Pass Renewal";
  this.getPassList();
  }

  changeLanguage()
  {
    if(this.getlen=='en')
    {
      this.lblPassType="Pass Type";
      this.lblFreqType="Frequency Type";
      this.lblPassAmt="Pass Amount";
      this.lblMob="Mobile No";
      this.lblName="Name";
      this.lblPassNo="Pass No";
      this.lblExpiry="Pass Expiration Date";
      this.lblRenewFreq="Pass Renewal Frequency";
    }
    else if(this.getlen=='mr')
    {
      this.lblPassType="Pass Type";
      this.lblFreqType="Pass Frequency";
      this.lblPassAmt="Pass Amount";
      this.lblMob="Mobile No";
      this.lblName="Name";
      this.lblPassNo="Pass No";
      this.lblExpiry="Pass Expiration Date";
      this.lblRenewFreq="Pass Renewal Frequency";
    }else{
      this.lblPassType="Pass Type";
      this.lblFreqType="Frequency Type";
      this.lblPassAmt="Pass Amount";
      this.lblMob="Mobile No";
      this.lblName="Name";
      this.lblPassNo="Pass No";
      this.lblExpiry="Pass Expiration Date";
      this.lblRenewFreq="Pass Renewal Frequency";
    }
  }
  createForm() {
    this.newForm = new FormGroup({
      drpPassNo:new FormControl(""),
      txtFullname: new FormControl(""),
      txtMobileNo: new FormControl(""),
      txtRenewDate: new FormControl(),
      drpPassFreq: new FormControl(""),
      drpPassType: new FormControl(""),
      drpPassRenewFreq: new FormControl(""),
      txtAmount: new FormControl(""),
    });
  }

  show()
  {
    this.spinnerService.show();
    setTimeout(()=>this.spinnerService.hide(),50000);
  }

  getPassList()
  {
    this.lstPass=new PasssListByMobile();

    var mob=localStorage.getItem("mobileno_NMC");
    this.onlineservices.GetPassList(mob).pipe(first()).subscribe(result=>
      {
        if(result.data !=null)
        this.lstPass=result.data;
        console.log("Pass List"+this.lstPass);
        //console.log("Routes:",this.arr);
      });
  }

  getPassDetails(e)
  {
    debugger;
    this.lstPassDetails=new PassDetailsByPassNo();
    this.intFareAmountEN=0;
    this.onlineservices.GetPassDetailsByPassNo(e).pipe(first()).subscribe(result=>
      {
        if(result.data !=null)
        {
          console.log("result Pass Details List"+result.data);
          this.showData="true";
          this.lstPassDetails=result.data;
          this.objDetails=new PassDetailsByPassNo();
          for(let el of this.lstPassDetails)
          {
            debugger;
            this.objDetails=el;
          }
          console.log(this.objDetails)
          this.getFrequency(this.objDetails.intPassTypeID);
          this.newForm.controls.txtRenewDate.setValue("");
          this.newForm.controls.txtAmount.setValue(0);
        }
        else
        this.showData="false";

        console.log("Pass Details List"+this.lstPassDetails);
        //console.log("Routes:",this.arr);
      });
  }

  getFrequency(id)
  {
    debugger;
    this.lstFreqBytype=[];
    var GetFreqByType=new GetFrequencyByType();
      GetFreqByType.intPassMediaID=3;
      GetFreqByType.intPassTypeID=Number(id);
      //GetFreqByType.intTicketCategoryID=Number(id)==1?1:29;
      if(Number(id)==1)
         GetFreqByType.intTicketCategoryID=1;            //General
    else if(Number(id)==4)
        GetFreqByType.intTicketCategoryID=14;
    else if(Number(id)==3)
         GetFreqByType.intTicketCategoryID=29;           //Student

      GetFreqByType.intServiceTypeID=1;
      GetFreqByType.Username="abcd!@#%^&*()_123";
      GetFreqByType.Password="s@1_Dx*7s";
      this.onlineservices.GetPassDurationListByType(GetFreqByType).pipe(first()).subscribe(result => {
        if(result.data!=null)
        {
          console.log(result.data);
          if(result.data.length>0)
          {
            console.log(result.data);
            let lstFreqdemo:any=[];
            lstFreqdemo=result.data;

            var str=new String("");

            for(let el in lstFreqdemo)
            {
              this.lstFreqBytype[el]={
                intFrequencyID: result.data[el].intFrequencyID,
                strFrequencyName: str.concat(result.data[el].intFrequencyInDays + 1,' Days'),
                strFrequency : result.data[el].strFrequencyName,
                intFrequencyInDays:result.data[el].intFrequencyInDays,
                strPassFrequencyRegionalLanguage:str.concat(this.ReplaceNumbers(result.data[el].intFrequencyInDays + 1),' दिवस'),
              };
            }
          }

          }
          console.log("freq:"+this.lstFreqBytype);
      });
  }

  getFare(e)
  {
    debugger;
    var GetRouteByStationModel=new GetRouteByStation();
    this.objDetails.intFrequencyID = Number(e);
    this.objDetails.strFrequencyName = this.lstFreqBytype.filter(x => x.intFrequencyID == Number(e))[0].strFrequency;
    if(this.objDetails!=null)
    {
      GetRouteByStationModel.passTypeId=Number(this.objDetails.intPassTypeID);
      GetRouteByStationModel.passFrequencyID=Number(e);
      GetRouteByStationModel.passMediaId=3;
      GetRouteByStationModel.serviceTypeId=1;
      if(GetRouteByStationModel.passTypeId==1)
        GetRouteByStationModel.hhTicketCategoryID=1;            //General
      else if(GetRouteByStationModel.passTypeId==4)
        GetRouteByStationModel.hhTicketCategoryID=14;
      else if(GetRouteByStationModel.passTypeId==3)
        GetRouteByStationModel.hhTicketCategoryID=29;           //Student
      GetRouteByStationModel.sourceId=this.objDetails.intFromStationID;
      GetRouteByStationModel.destinationId=this.objDetails.intToStationID;
      console.log(GetRouteByStationModel);
      this.show();
     if(GetRouteByStationModel.passTypeId==2)
     {
     var GetFareModel=new GetFare();
      GetFareModel.intHHTicketCategoryID=1;
      GetFareModel.intPassMediaID=3;
      GetFareModel.intPassTypeID=2;
      GetFareModel.intServiceTypeID=1;
     GetFareModel.strCityID="8";
      GetFareModel.intPassFrequencyID=Number(e);
      //console.log(this.f.PassActivationDateUnltd.valid);

      // [{
      //     intRouteID:null,
      //     intFromStationID:null,
      //     intToStationID:null
      //   }];
        GetFareModel.lstSelRoute=[];
        // console.log("route Model:",GetFareModel);
        this.onlineservices.GetPassFareCalculation(GetFareModel).pipe(first()).subscribe(result =>
        {
          // console.log("Unlimited:",result);
          debugger;
          if(result!=null)
          {
            var objUrl=new UnltdPassResponse();
            objUrl=JSON.parse(JSON.stringify(result));
            if(objUrl.passFareCalculationValues!=null)
            {
              if(objUrl.passFareCalculationValues.length>0)
              {
               // this.lstUnltdFare=new FareCalculationUnLtd;
               // this.lstUnltdFare=objUrl.passFareCalculationValues;
                // console.log("Unlimited",this.lstUnltdFare);
                if(this.getlen=='mr')
                this.intFareAmount=this.ReplaceNumbers((objUrl.passFareCalculationValues[0].intJourneyFare/100).toString());
                else
                this.intFareAmount=objUrl.passFareCalculationValues[0].intJourneyFare/100;
                this.intFareAmountEN=objUrl.passFareCalculationValues[0].intJourneyFare/100;
                this.lstPassDetails.push([{
                  intFromStationID:null,
              intToStationID:null ,
              bUnlimitedTravel:objUrl.passFareCalculationValues[0].bUnlimitedTravel,
              intMaxCreditJourny:objUrl.passFareCalculationValues[0].intMaxCreditJourney,
              intMaxTripsPerDay:objUrl.passFareCalculationValues[0].intMaxTripsPerDay,
              strDiscountUnit:objUrl.passFareCalculationValues[0].strDiscountUnit,
              strSelectedRouteID:null,

              intFareComponentId:0,
              decTotalAppliedTaxAmount:0,
              decTaxValue:0,
              decAdjustmentAmount:0,
              intMathOperationId:0,
              intPassFareComponentID:0,
              intPassDiscountGroupID:null,
              strTaxCalculateIn:null,
              decDiscount:objUrl.passFareCalculationValues[0].intDiscountValue/100,

              intTotalAmount:this.intFareAmountEN*100,
              intPassConfigID:objUrl.passFareCalculationValues[0].intPassConfigID,
              intPassFrequencyConfigurationID:objUrl.passFareCalculationValues[0].intPassFrequencyConfigurationID,
                }])

                // console.log(objUrl.passFareCalculationValues[0].intJourneyFare);
                var lst=this.lstFreqBytype.find(x=>x.intFrequencyID===e);
                if(this.objDetails.isExpired==true)
                {
                  // var cur=new Date();
                  // console.log(cur);
                  this.dteReneew=new Date();
                 this.dteReneew.setDate(this.dteReneew.getDate()+lst.intFrequencyInDays);
                  this.dteActivate=new Date();
                // this.dteActivate.setDate( this.dteActivate.getDate());
                }
                else
                {
                  // var exp=new Date(this.objDetails.dtePassExpiryDate);
                  var exp=(moment(this.objDetails.dtePassExpiryDate,"DD-MM-yyyy")).toDate();
                  this.dteReneew=new Date(exp);
                this.dteReneew.setDate(this.dteReneew.getDate()+lst.intFrequencyInDays);
                this.dteActivate=new Date(exp);
                this.dteActivate.setDate( this.dteActivate.getDate()+1);
                }
                this.newForm.controls.txtRenewDate.setValue(this.dteReneew);
              }

            }
            else
            {
              this.intFareAmount=0;
              this.intFareAmountEN=0;
            }

          }

        //   //this.spinnerService.hide();
        });
        // this.GetPassFareCalculation(GetFareModel);
     }
     else
     {
      this.onlineservices.GetRouteListByStation(GetRouteByStationModel).pipe(first()).subscribe(result=>
        {
          if(result.data.length>0)
          {
            console.log(result.data);
            this.lstRoute=result.data;
            console.log("List Of Routes:",this.lstRoute);
            if(this.lstRoute[0].halt!=null)
            {
              if(this.lstRoute[0].halt.length>0)
              {
                //this.lstSelectedRouteFare=new FareCalculation;
                this.lstSelectedRouteFare=[];
                this.lstMax=[];
                var lstDemo:any=[];
                console.log("halt json=>"+JSON.parse(this.lstRoute[0].halt));
                debugger;
                for(let el in this.lstRoute)
                {
                  lstDemo.push({arraylst:JSON.parse(this.lstRoute[el].halt)});
                  console.log(lstDemo);
                }
                for(let e in lstDemo)
                {
                  if(lstDemo[e].arraylst[0].JourneyFare>0)          //as journey deails is getting null
                  {
                    this.lstSelectedRouteFare.push({
                      JourneyFare:lstDemo[e].arraylst[0].JourneyFare,
                      RouteName:lstDemo[e].arraylst[0].RouteParentName,
                      JourneyFareDetails:JSON.parse(lstDemo[e].arraylst[0].JourneyFareDetails),
                      isCheked:false
                    });
                  }
                }

                if(this.lstSelectedRouteFare!=null)
                {
                  debugger;
                  this.showData="true";
                  console.log("list:"+this.lstSelectedRouteFare);
                for(let e in this.lstSelectedRouteFare)
                {
                  this.lstMax.push(
                    {
                      fare:this.lstSelectedRouteFare[e].JourneyFare/100,
                      details:this.lstSelectedRouteFare[e].JourneyFareDetails[0]
                    });
                    this.lstSelRouteMax.push(
                      {
                        route:this.lstSelectedRouteFare[e].JourneyFareDetails[0].strSelectedRouteID,
                      }
                    );
                    console.log("max list"+this.lstMax);
                    console.log("sel routes:"+this.lstSelRouteMax);
                    let max = this.lstMax.reduce(function(prev, current) {
                      return (prev.fare < current.fare) ? prev.details : current.details
                  }) ;//
                  var lstData=JSON.parse(JSON.stringify(this.lstMax[e].details));
                      console.log("Lst Data:"+lstData);
                }

                  this.lstSelectedRoutesWithFare[0]=(
                    {
                      intFromStationID:lstData.intFromStationID,
                      intToStationID:lstData.intToStationID,
                      bUnlimitedTravel:lstData.bUnlimitedTravel,
                      intMaxCreditJourny:lstData.intMaxCreditJourny,
                      intMaxTripsPerDay:lstData.intMaxTripsPerDay,
                      intPassConfigID:lstData.intPassConfigID,
                      intPassFrequencyConfigurationID:lstData.intPassFrequencyConfigurationID,
                      strDiscountUnit:lstData.strDiscountUnit,
                      strSelectedRouteID:lstData.strSelectedRouteID,
                      intFareComponentId:lstData.intFareComponentId,
                      decTotalAppliedTaxAmount:lstData.decTotalAppliedTaxAmount,
                      // dteIssueDate:fromnatnew Date(),
                      // dtePassExpiryDate:,
                      //intSingleJourneyFare:type.intJourneyFare,
                      decDiscount:lstData.decDiscount,
                      decTaxValue:lstData.decTaxValue,
                      decAdjustmentAmount:lstData.decAdjustmentAmount,
                      intMathOperationId:lstData.intMathOperationId,
                      intPassFareComponentID:lstData.intPassFareComponentID,
                      intPassDiscountGroupID:lstData.intPassDiscountGroupID,
                      strTaxCalculateIn:lstData.strTaxCalculateIn,
                      intTotalAmount:lstData.intTotalAmount,

                    });
                    console.log(this.lstSelectedRoutesWithFare);
                    for(let e in this.lstSelRouteMax)
                    {
                      this.strSelRoute+=this.strSelRoute!=""?","+this.lstSelRouteMax[e].route:this.lstSelRouteMax[e].route;
                    }
                    console.log(this.strSelRoute);

                  if(this.getlen=='mr')
                  this.intFareAmount=this.ReplaceNumbers(Math.min.apply(Math, this.lstSelectedRouteFare.map(function(o) { return o.JourneyFare/100; })));
                  else
                  this.intFareAmount=Math.min.apply(Math, this.lstSelectedRouteFare.map(function(o) { return o.JourneyFare/100; }));
                  this.intFareAmountEN=Math.min.apply(Math, this.lstSelectedRouteFare.map(function(o) { return o.JourneyFare/100; }));;
                }
                else
                  this.showData="false";
                 console.log(this.lstSelectedRouteFare);
                 console.log(this.intFareAmount);
                 console.log(this.showData);
                this.dteReneew=new Date();
                 if(this.lstFreqBytype!=null)
                 {
                   debugger;
                    var lst=this.lstFreqBytype.find(x=>x.intFrequencyID===e);
                    // dte.setDate(dte.getDate()+intday);
                    // console.log(lst);
                    // console.log(lst.intFrequencyInDays);
                    if(this.objDetails.isExpired==true)
                    {
                      // var cur=new Date();
                      // console.log(cur);
                      this.dteReneew=new Date();
                     this.dteReneew.setDate(this.dteReneew.getDate()+lst.intFrequencyInDays);
                      this.dteActivate=new Date();
                    // this.dteActivate.setDate( this.dteActivate.getDate());
                    }
                    else
                    {
                      // var exp=new Date(this.objDetails.dtePassExpiryDate);
                      var exp=(moment(this.objDetails.dtePassExpiryDate,"DD-MM-yyyy")).toDate();
                      this.dteReneew=new Date(exp);
                    this.dteReneew.setDate(this.dteReneew.getDate()+lst.intFrequencyInDays);
                    this.dteActivate=new Date(exp);
                    this.dteActivate.setDate( this.dteActivate.getDate()+1);
                    }
                    this.newForm.controls.txtRenewDate.setValue(this.dteReneew);


                    console.log(this.dteActivate);
                    console.log(this.dteReneew);
                 }

              }
            }
            // else
            // this.showFare=2;
          }
          this.spinnerService.hide();
        },err => {
          this.notifyService.showError(err, 'Error');
          // this.showFare=2;
          debugger;
          this.spinnerService.hide();
        });
     }
    }
  }
  get f() { return this.newForm.controls; }

  // InsertRenewData()
  // {
  //   debugger;
  //   this.lstPassDetails=InsertPassRenew;

  //     if(this.lstSelectedRoutesWithFare!=null)
  //     {
  //       if(this.objDetails!=null)
  //       {
  //         if(this.lstSelectedRoutesWithFare.length>0)
  //         {
  //           debugger;
  //           this.lstPassDetails = [];
  //         debugger;
  //         for(let e in this.lstSelRouteMax)
  //         {
  //           this.strSelRoute+=this.strSelRoute!=""?","+this.lstSelRouteMax[e].route:this.lstSelRouteMax[e].route;
  //         }
  //         // console.log("Selected route:"+this.strSelRoute);
  //         for (let element in this.lstSelectedRoutesWithFare) {
  //           debugger;
  //           this.lstPassDetails.push({
  //             intFromStationID:this.lstSelectedRoutesWithFare[element].intFromStationID,
  //             intToStationID: this.lstSelectedRoutesWithFare[element].intToStationID ,
  //             bUnlimitedTravel:this.lstSelectedRoutesWithFare[element].bUnlimitedTravel,
  //             intMaxCreditJourny:this.lstSelectedRoutesWithFare[element].intMaxCreditJourny,
  //             intMaxTripsPerDay:this.lstSelectedRoutesWithFare[element].intMaxTripsPerDay,
  //             strDiscountUnit:this.lstSelectedRoutesWithFare[element].strDiscountUnit,
  //             strSelectedRouteID:this.strSelRoute,
  //             intFareComponentId:this.lstSelectedRoutesWithFare[element].intFareComponentId,
  //             decTotalAppliedTaxAmount:this.lstSelectedRoutesWithFare[element].decTotalAppliedTaxAmount,
  //             decTaxValue:this.lstSelectedRoutesWithFare[element].decTaxValue,
  //             decAdjustmentAmount:this.lstSelectedRoutesWithFare[element].decAdjustmentAmount,
  //             intMathOperationId:this.lstSelectedRoutesWithFare[element].intMathOperationId,
  //             intPassFareComponentID:this.lstSelectedRoutesWithFare[element].intPassFareComponentID,
  //             intPassDiscountGroupID:this.lstSelectedRoutesWithFare[element].intPassDiscountGroupID,
  //             strTaxCalculateIn:this.lstSelectedRoutesWithFare[element].strTaxCalculateIn,

  //             //dteIssueDate:formatDate(new Date(),"dd/MM/yyyy hh:mm:ss") ,
  //            // intSingleJourneyFare:this.lstSelectedRoutesWithFare[element].intSingleJourneyFare,
  //             decDiscount:this.lstSelectedRoutesWithFare[element].decDiscount,
  //             // intTotalAmount:this.lstSelectedRoutesWithFare[element].intTotalAmount,
  //             intTotalAmount:this.intFareAmountEN*100,
  //             intPassConfigID:this.lstSelectedRoutesWithFare[element].intPassConfigID,
  //             intPassFrequencyConfigurationID:this.lstSelectedRoutesWithFare[element].intPassFrequencyConfigurationID,
  //           })
  //         }

  //         var InsertPassModel=new InsertPassRenew;
  //         // InsertPassModel.intPassUserID=Number(localStorage.getItem("user_NMC"));
  //         // InsertPassModel.phone=localStorage.getItem("mobileno_NMC");7227988373
  //         InsertPassModel.intPassUserID=Number(localStorage.getItem("user_NMC"));
  //         InsertPassModel.phone=localStorage.getItem("mobileno_NMC");
  //         InsertPassModel.productinfo="pass";
  //         InsertPassModel.intLocationTypeID=9;
  //         InsertPassModel.PaymentModeId=10;
  //         if(this.objDetails.intPassTypeID==1)
  //         InsertPassModel.intHHTicketCategoryID=1;
  //         else
  //         InsertPassModel.intHHTicketCategoryID=29;
  //         InsertPassModel.intFrequencyID=this.objDetails.intFrequencyID;
  //         InsertPassModel.intPassTypeID=this.objDetails.intPassTypeID;
  //         InsertPassModel.intServiceTypeID=1;
  //         InsertPassModel.intPassMediaID=4;             //offline
  //         InsertPassModel.intPaymentGatewayID=2;
  //         // InsertPassModel.dtePassActivationDate=formatDate(this.editForm.controls.PassActivationDate.value, "yyyy-MM-dd");
  //         InsertPassModel.dtePassActivationDate=formatDate(this.dteActivate,"yyyy-MM-dd");
  //         InsertPassModel.dtePassRenewExpiryDate=formatDate(this.newForm.controls.txtRenewDate.value,"yyyy-MM-dd");
  //         InsertPassModel.intParentPassIssuanceID=this.objDetails.intPassIssuanceID;
  //         InsertPassModel.PassDetails=this.lstPassDetails;

  //         console.log(InsertPassModel);
  //         this.onlineservices.InsertPassRenew(InsertPassModel).pipe().subscribe(result =>
  //           {
  //             if(result.data!=null)
  //             {
  //               this.lstPassPG=result.data;
  //               // console.log(this.lstPassPG);
  //               if(this.lstPassPG.passDetails!=null)
  //               {
  //                 debugger;
  //                 this.ObjPassDeailsPG.paymentOrderNo=this.lstPassPG.passDetails[0].paymentOrderNo;
  //                 this.notifyService.showSuccess("“Your Pass has been renewed/recharged and the new validity date is :"+InsertPassModel.dtePassRenewExpiryDate,result.message);
  //                 // var Order_no=result.data.passDetails[0].paymentOrderNo.toString();
  //                  this.objCommonclass.CallPaymentGatewayApp(this.ObjPassDeailsPG.paymentOrderNo);
  //               }

  //             }
  //             else
  //             this.notifyService.showError("Something Went wrong",result.message);

  //           }
  //         }
  //         else
  //       this.notifyService.showWarning("Please select routes!....","warning");

  //       }
  //       else
  //         this.notifyService.showError("Something went wrong!....","ERROR");
  //     }
  //     else
  //     this.notifyService.showError("Something went wrong!....","ERROR");
  // }
  InsertRenewData()
  {
    debugger;
    if(this.objDetails.intPassTypeID == 2){
      this.lstPassDetails = this.lstPassDetails[this.lstPassDetails.length - 1];
    }
    else{
    this.lstPassDetails=InsertPassRenew;
  }

      if(this.lstSelectedRoutesWithFare!=null)
      {
        if(this.objDetails!=null)
        {

          if(this.lstSelectedRoutesWithFare.length>0 || this.objDetails.intPassTypeID == 2)
          {
            debugger;
            if(this.objDetails.intPassTypeID != 2){
            this.lstPassDetails = [];
          }
          debugger;
          if(this.objDetails.intPassTypeID != 2){

          for(let e in this.lstSelRouteMax)
          {
            this.strSelRoute+=this.strSelRoute!=""?","+this.lstSelRouteMax[e].route:this.lstSelRouteMax[e].route;
          }
          // console.log("Selected route:"+this.strSelRoute);
          for (let element in this.lstSelectedRoutesWithFare) {
            debugger;
            this.lstPassDetails.push({
              intFromStationID:this.lstSelectedRoutesWithFare[element].intFromStationID,
              intToStationID: this.lstSelectedRoutesWithFare[element].intToStationID ,
              bUnlimitedTravel:this.lstSelectedRoutesWithFare[element].bUnlimitedTravel,
              intMaxCreditJourny:this.lstSelectedRoutesWithFare[element].intMaxCreditJourny,
              intMaxTripsPerDay:this.lstSelectedRoutesWithFare[element].intMaxTripsPerDay,
              strDiscountUnit:this.lstSelectedRoutesWithFare[element].strDiscountUnit,
              strSelectedRouteID:this.strSelRoute,
              intFareComponentId:this.lstSelectedRoutesWithFare[element].intFareComponentId,
              decTotalAppliedTaxAmount:this.lstSelectedRoutesWithFare[element].decTotalAppliedTaxAmount,
              decTaxValue:this.lstSelectedRoutesWithFare[element].decTaxValue,
              decAdjustmentAmount:this.lstSelectedRoutesWithFare[element].decAdjustmentAmount,
              intMathOperationId:this.lstSelectedRoutesWithFare[element].intMathOperationId,
              intPassFareComponentID:this.lstSelectedRoutesWithFare[element].intPassFareComponentID,
              intPassDiscountGroupID:this.lstSelectedRoutesWithFare[element].intPassDiscountGroupID,
              strTaxCalculateIn:this.lstSelectedRoutesWithFare[element].strTaxCalculateIn,

              //dteIssueDate:formatDate(new Date(),"dd/MM/yyyy hh:mm:ss") ,
             // intSingleJourneyFare:this.lstSelectedRoutesWithFare[element].intSingleJourneyFare,
              decDiscount:this.lstSelectedRoutesWithFare[element].decDiscount,
              // intTotalAmount:this.lstSelectedRoutesWithFare[element].intTotalAmount,
              intTotalAmount:this.intFareAmountEN*100,
              intPassConfigID:this.lstSelectedRoutesWithFare[element].intPassConfigID,
              intPassFrequencyConfigurationID:this.lstSelectedRoutesWithFare[element].intPassFrequencyConfigurationID,
            })
          }}
          var InsertPassModel=new InsertPassRenew;
          // InsertPassModel.intPassUserID=Number(localStorage.getItem("user_NMC"));
          // InsertPassModel.phone=localStorage.getItem("mobileno_NMC");7227988373
          InsertPassModel.intPassUserID=Number(localStorage.getItem("user_NMC"));
          InsertPassModel.phone=localStorage.getItem("mobileno_NMC");
          InsertPassModel.productinfo="pass";
          InsertPassModel.intLocationTypeID=9;
          InsertPassModel.PaymentModeId=10;
          if(this.objDetails.intPassTypeID==1)
          InsertPassModel.intHHTicketCategoryID=1;
          else
          InsertPassModel.intHHTicketCategoryID=29;
          InsertPassModel.intFrequencyID=this.objDetails.intFrequencyID;
          InsertPassModel.intPassTypeID=this.objDetails.intPassTypeID;
          InsertPassModel.intServiceTypeID=1;
          InsertPassModel.intPassMediaID=4;             //offline
          // InsertPassModel.intPaymentGatewayID=2; 
          InsertPassModel.intPaymentGatewayID=4; //Qfix
          // InsertPassModel.dtePassActivationDate=formatDate(this.editForm.controls.PassActivationDate.value, "yyyy-MM-dd");
          InsertPassModel.dtePassActivationDate=formatDate(this.dteActivate,"yyyy-MM-dd");
          InsertPassModel.dtePassRenewExpiryDate=formatDate(this.newForm.controls.txtRenewDate.value,"yyyy-MM-dd");
          InsertPassModel.intParentPassIssuanceID=this.objDetails.intPassIssuanceID;
          InsertPassModel.PassDetails=this.lstPassDetails;

          console.log(InsertPassModel);
          this.onlineservices.InsertPassRenew(InsertPassModel).pipe().subscribe(result =>
            {
              if(result.data!=null)
              {
                this.lstPassPG=result.data;
                // console.log(this.lstPassPG);
                if(this.lstPassPG.passDetails!=null)
                {
                  debugger;
                  this.ObjPassDeailsPG.paymentOrderNo=this.lstPassPG.passDetails[0].paymentOrderNo;
                  this.notifyService.showSuccess("“Your Pass has been renewed/recharged and the new validity date is :"+InsertPassModel.dtePassRenewExpiryDate,result.message);
                  // var Order_no=result.data.passDetails[0].paymentOrderNo.toString();
                   this.objCommonclass.CallPaymentGatewayApp(this.ObjPassDeailsPG.paymentOrderNo);
                }

              }
              else
              this.notifyService.showError("Something Went wrong",result.message);

            });
          }
          else
        this.notifyService.showWarning("Please select routes!....","warning");

        }
        else
          this.notifyService.showError("Something went wrong!....","ERROR");
      }
      else
      this.notifyService.showError("Something went wrong!....","ERROR");
  }
  public ReplaceNumbers(input:string)
  {
    debugger;
      // for (var num in this.marathiArray)
      // {
        var no=Number(input);
        if (input === null || input === undefined) return '';
          input = input + ''; // to make it a string if it was a number
        let newString = '';
        for (let i = 0; i < input.length; i++) {
          if (this.marathiArray[input.charAt(i)])
          {
            var c=Number(input.charAt(i));
            newString += this.marathiArray[c].id;
          }

          else
            newString += input.charAt(i);
        }
          //input = input.toString().replace(/input/, this.marathiArray[num].no);
      // }
      return newString;
  }
}

@Component({
  selector: 'route.design.popup',
  templateUrl: 'route.design.popup.html',
})
export class RouteMapDialog{
  @ViewChild('map', { static: true }) mapElement: any;
  map: google.maps.Map;

  public isLoadingHome: boolean = false;
  public timeline_tripdetailsdata: Array<any> = [];
  public isTableHasData: boolean;
  public showTripDetailContent: Boolean = true;
  public markerdes: google.maps.Marker;
  public markersource: google.maps.Marker;
  public currmarker: google.maps.Marker;
  public subscription1: Subscription;
  public TripRouteNo: any;
  public TripVehicleNo: any;
  public activeinfowindow: google.maps.InfoWindow;
  public routewaypointsmapdata: Array<any> = [];
  public StationList: any =[];
  public markers = [];
  public polyline: google.maps.Polyline;

  constructor(private viewRoutesService: ViewRoutesService, private journeyService: PlanjourneyService,
    private BusService: BusService) {}

  ngOnInit(): void{
    var lat = data[0].Latitude;
    var long = data[0].Longitude;
    const mapProperties = {
      center: new google.maps.LatLng(lat, long),
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapProperties);
    var rno = LocalstorageService.getLocal("RouteNoForMap");
    //this.TripPlotOnMap();
    this.StationsListByRoute();
  }

  public introuteid: number;
  public routeDetailsGroupBy: any = [];
  public routeDetails: Array<{ routeid: string, stopno: string, stopname: string, distance: string, tripid: string, eta: string, tripname: string, iscovered: string }>
  GetDetailsOfRoutes(routeid) {
    this.introuteid = routeid;
    this.routeDetailsGroupBy = [];
    this.viewRoutesService.GetRouteDetails(routeid).pipe(first()).subscribe(result => {
      this.routeDetails = JSON.parse(result.data); //list of all trip records
      //group by with trip id
      const example = from(this.routeDetails).pipe(groupBy(person => person.tripid),
        mergeMap(group => group.pipe(toArray())));
      example.subscribe(val => this.routeDetailsGroupBy.push(val[0], val[val.length - 1]))
    });
  }

  CreateInfoWindow(marker, title) {
    const infowindow = new window['google'].maps.InfoWindow({
      content: title
    });
    marker.setMap(this.map)
    google.maps.event.addListener(marker, 'click', () => {
      if (this.activeinfowindow) { this.activeinfowindow.close(); }
      infowindow.open(this.map, marker);
      this.activeinfowindow = infowindow;
    });
  }

  StationsListByRoute() {
    var routeid = LocalstorageService.getLocal("RouteNoForMap");
    this.BusService.GetAllStationsOnRoute(Number(routeid),1).pipe(first()).subscribe(result => {
      this.StationList = JSON.parse(result.data);

      var latlongmarkerbounds = [];
      for (var i = 0; i < this.StationList.length; i++) {
        var lat = this.StationList[i]["center_lat"];
        var long = this.StationList[i]["center_lon"];
        var stationname = this.StationList[i]["displayname"];
        var title = "<b>Stop Name</b> : " + stationname;
        let latLng = { lat: Number(lat), lng: Number(long) };
        latlongmarkerbounds.push(new google.maps.LatLng(Number(lat), Number(long)));
        this.map.setCenter(new google.maps.LatLng(Number(lat), Number(long)));
        var icon;
        if (i === 0) {
          icon = {
            url: "assets/images/mapIcon.1.svg", // url
          }
        }
        else if (i === this.StationList.length - 1) {
          icon = {
            url: "assets/images/mapIcon.2.svg", // url
          }
        }
        else {
          icon = {
            url: "assets/images/mapIcon.svg", // url
          }
        }

        const marker = new google.maps.Marker({
          position: latLng,
          map: this.map,
          title: stationname,
          icon: icon
        });
        this.CreateInfoWindow(marker, title);
        this.markers.push(marker);
      }
      });
      this.PlotRoute();
  }

  PlotRoute() {
    var routeid = LocalstorageService.getLocal("RouteNoForMap");

    this.journeyService.GetRouteWayPoints(routeid).pipe(first()).subscribe(result => {
      this.routewaypointsmapdata = JSON.parse(result.data);
      var path = [];
      for (var i = 0; i < this.routewaypointsmapdata.length; i++) {
        var lat1 = this.routewaypointsmapdata[i]["routelat"];
        var long1 = this.routewaypointsmapdata[i]["routelong"];
        path.push(new google.maps.LatLng(Number(lat1), Number(long1)));
      }

      this.polyline = new google.maps.Polyline({
        map: this.map,
        path: path,
        strokeColor: '#114a97',
        strokeOpacity: 0.8,
        strokeWeight: 6,
        geodesic: true,
      })
      this.polyline.setMap(this.map);
    });
  }

}

@Component({
  selector: 'time_table.design.popup',
  templateUrl: 'time_table.design.popup.html',
})
export class TimeTableDialog{
  ShowTimeTable: boolean = true;
  public TimeTableList: any = [];
  public StationName: any = [];
  getlen: string;
  TimetableLan: any;
  DisRouteName: any;
  DisRouteType: any;
  DisplayFullRouteNAme: any;

  constructor(private BusService: BusService) {
    this.getlen = LocalstorageService.getLanguage("language");

  }

  ngOnInit() {
    this.DisRouteName = LocalstorageService.getLocal("NameOfRoutes");
    this.GetRouteTimeTable();
    if(this.getlen=='en'){
      this.TimetableLan='Time Table';
    } else if(this.getlen=='mr') {
      this.TimetableLan ='वेळापत्रक';
    } else {
      this.TimetableLan='Time Table';
    }
  }

  GetRouteTimeTable() {
    var routeid = LocalstorageService.getLocal("RouteNoForMap");
    // this.DisRouteName = LocalstorageService.getLocal("NameOfRoutes");
    this.DisplayFullRouteNAme = LocalstorageService.getLocal("NameOfRoutes");
    // console.log(this.DisplayFullRouteNAme);
    this.BusService.GetAllStationsOnRoute(Number(routeid), 2).pipe(first()).subscribe(result => {
      this.TimeTableList = JSON.parse(result.data);
      var ListLength = this.TimeTableList.length;
      if(ListLength>0) {
        this.ShowTimeTable = true;
      } else {
        this.ShowTimeTable = false;
      }
    });
  }

}

@Component({
  selector: 'stops.design.popup',
  templateUrl: 'stops.design.popup.html',
  styleUrls: ['./busservices.component.scss']
})
export class StopsDialog{

  public routeid: string;
  public StationList: any =[];
  public SrNo: string;
  public BusStops: string;
  public getlen: string;
  constructor(private BusService: BusService) { }


  ngOnInit(){
    this.routeid = LocalstorageService.getLocal("RouteNoForMap");
    this.getlen = LocalstorageService.getLanguage("language");
    if(this.getlen == 'en') {
      this.SrNo = "SR No";
      this.BusStops = "Bus Stops";
    } else if(this.getlen == 'mr') {
      this.SrNo = "अनु.क्र.";
      this.BusStops = "बस थांब्यांची यादी";
    }
    this.StationsListByRoute();
  }


  StationsListByRoute() {

    this.BusService.GetAllStationsOnRoute(Number(this.routeid), 3).pipe(first()).subscribe(result => {
      this.StationList = JSON.parse(result.data);
    });
  }
}
